module.exports = __webpack_public_path__ + "static/02-cc03dfa555774fd4c77f882b67fe5b7b.jpg";